export const customSelect = (target, callback) => {

    let customSelect = document.querySelector(".custom-select");
    let customSelectOptions = customSelect.querySelectorAll(".option");
    let fakeInput = document.querySelector(".fake-input");
    let fakeInputValue = fakeInput.querySelector(".value");
    let select = document.querySelector(target);
    const selectsOptions = Array.from(select.children);
    fakeInput.addEventListener("click", () => {
        customSelect.classList.toggle("d-none");
    });
    customSelectOptions.forEach((option) => {
        option.addEventListener("click", () => {
            let optionS = selectsOptions.find(val => val.innerHTML == option.innerHTML)
            select.value = optionS.value; // Ustawienie wybranej wartości
            $(target).valid();
            select.dispatchEvent(new Event('change'));
            fakeInputValue.innerHTML = option.innerHTML;
            customSelect.classList.toggle("d-none");
            if (callback) {
                callback(optionS.value)
            }
        });
    });
    customSelect.style.width = fakeInput.getBoundingClientRect().width + "px";
}